import styled from 'styled-components'

const ThemedCheckbox = styled.input.attrs({ type: 'checkbox' })`
  appearance: none;
  background-color: transparent;
  margin: 2px 0 0 !important; /* shared checkbox styles from rails asset pipeline clash with this property */

  font: inherit;
  height: 20px;
  width: 20px;
  border: 2px solid ${({ theme }) => theme?.['-ds-neutral-600']?.value};
  transform: translateY(
    -1px
  ); /* move upwards by half the width of the border */
  border-radius: 3px;

  flex-shrink: 0;
  display: grid;
  place-content: center;

  &:checked {
    background-color: ${({ theme }) => theme?.['-ds-core-400']?.value};
    border-color: ${({ theme }) => theme?.['-ds-core-400']?.value};
  }

  &::before {
    content: '';
    width: 10px;
    height: 10px;
    transform: scale(0); /* invisible */
    transition: 120ms transform ease-in-out;
    box-shadow: inset 20px 20px
      ${({ theme }) => theme?.['-ds-neutral-100']?.value};
    transform-origin: bottom left;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  }

  &:checked::before {
    transform: scale(1); /* visible */
  }

  &:focus {
    /* needs important tag to avoid clashing with bootstrap styles */
    outline: 2px solid !important;
    outline-offset: 3px !important;
  }
`

export default ThemedCheckbox
